import PixiSymbols from "../../framework/src/engine/pixi/PixiSymbols";
import AdvancedSymbol from "./AdvancedSymbol";
import SpecialSymbol from "./SpecialSymbol";


export default class SymbolFactory extends PixiSymbols {


    constructor(config: any, layers: any) {
        super(config, layers);
    }

    createByIndex(index: number, { name = null, blur = false }: { name?: string, blur?: boolean }) {
        
        let symbolName = this.getSymbolNameByIndex(index);
        
        let symbol;
        /*
         *  symbol is created using 
         *  - advancedSymbol (has jump animation and normal sprite animation)
         *   or
         *  - specialSymbol (has only sprite animation)
         *  at construction only single sprite is created , but in wincotroller the other (fireBack, sprite2, animated sprite, particles , multiplier sprite)
         *  children are created, calling the create method on each symbol on the fly
         */

        //switch(index) {            
        switch (symbolName) {
            // case "symbol_Axe"://7: 6:
            // case "symbol_Helmet"://8: 
            // symbol = new AdvancedSymbol(symbolName, index, blur);//AdvancedSymbol(symbolName, index, blur);           
            // break;
            //9:
            case 'symbol_Wild':
            case 'symbol_Woman':
            case 'symbol_Viking':
            case 'symbol_Scatter':
                symbol = new SpecialSymbol(symbolName, index, blur);
                break;
            default:
                //symbol = new BaseSymbol(symbolName, index, blur);
                // symbol = new NormalSymbol(symbolName, index, blur);
                symbol = new AdvancedSymbol(symbolName, index, blur);                
                break;
        }
        return symbol;
    }
}